import React, { useEffect, useState } from 'react';
import { AolGroup } from 'src/types/ViewModel/AolItem';
import { BunkeringListItem, BunkeringListItemWrapper } from './BunkeringDateList.styles';
import { DateTimeFormat, formatDateTime, prettifyDate } from 'odfjell-date-time-utils/dateTimeFormatter';
import RobDateStatusIcon from './RobDateStatusIcon';
import { getBunkeringEventsInAolGroupPeriod } from '../BunkeringUtils';
import { useBunkerContext } from 'src/context/BunkerContext';
import { BunkeringDateStatusEnum } from 'src/enums/bunkering/bunkeringDateStatusEnum';
import { RobDateStatusEnum } from 'src/enums/bunkering/robDateStatusEnum';
import BunkeringDateStatusIcon from './BunkeringDateStatusIcon';
import { BunkeringStatusEnum } from 'src/types/ViewModel/Bunkering/BunkeringEvent';
import { getRobDateStatus } from '../bunker-rob-page/RobUtils';
import { useVesselStore } from 'src/context/VesselContext';
import { useAolStore } from 'src/context/AolContext';

interface BunkeringDateListItemProps {
    date: Date;
    aolGroup: AolGroup | null;
    onSelectCalendarDate: (selectedDate: Date) => void;
    isSelected: boolean;
}

const BunkeringDateListItem: React.FC<BunkeringDateListItemProps> = (props) => {
    const { bunkerings, bunkeringEvents, fuelRobData } = useBunkerContext();
    const { vessel } = useVesselStore();
    const { aolDataItems } = useAolStore();
    const [robDateStatus, setRobDateStatus] = useState<RobDateStatusEnum>(RobDateStatusEnum.aolIncomplete);
    const [bunkeringEventStatus, setBunkeringEventStatus] = useState<BunkeringDateStatusEnum>(BunkeringDateStatusEnum.noBunkering);

    useEffect(() => {
        if (!props.aolGroup || !bunkerings || !fuelRobData) return;
        const newStatus = getRobDateStatus(vessel, props.aolGroup, aolDataItems, props.date, bunkerings, fuelRobData);
        setRobDateStatus(newStatus);
    }, [props.aolGroup, props.date, bunkerings, fuelRobData, aolDataItems, vessel]);

    useEffect(() => {
        if (!bunkeringEvents || bunkeringEvents.length === 0) {
            setBunkeringEventStatus(null);
            return;
        }
        const bunkeringEventsInAolGroupPeriod = getBunkeringEventsInAolGroupPeriod(props.date, bunkeringEvents).filter((b) => !b.debunkering);
        const bunkeringsInAolGroupPeriod = bunkerings.filter((bunkering) =>
            bunkeringEventsInAolGroupPeriod?.some((bunkeringEvent) => bunkering.eventId === bunkeringEvent.eventID)
        );
        const unregisteredBunkerings = bunkeringEventsInAolGroupPeriod.some((bunkeringEvent) => {
            return !bunkerings.some((bunkering) => bunkering.eventId === bunkeringEvent.eventID);
        });
        if (unregisteredBunkerings) {
            setBunkeringEventStatus(BunkeringDateStatusEnum.unregisteredBunkering);
        } else if (bunkeringsInAolGroupPeriod?.length > 0) {
            if (bunkeringsInAolGroupPeriod.some((bunkering) => bunkering.currentStatus?.status === BunkeringStatusEnum.Registered)) {
                setBunkeringEventStatus(BunkeringDateStatusEnum.registeredBunkering);
            } else if (
                bunkeringsInAolGroupPeriod.some(
                    (bunkering) =>
                        bunkering.currentStatus?.status === BunkeringStatusEnum.Approved ||
                        bunkering.currentStatus?.status === BunkeringStatusEnum.InUse
                )
            ) {
                setBunkeringEventStatus(BunkeringDateStatusEnum.approvedOrInUseBunkering);
            } else if (bunkeringsInAolGroupPeriod.some((bunkering) => bunkering.currentStatus?.status === BunkeringStatusEnum.Rejected)) {
                setBunkeringEventStatus(BunkeringDateStatusEnum.rejectedBunkering);
            } else if (bunkeringsInAolGroupPeriod.some((bunkering) => bunkering.currentStatus?.status === BunkeringStatusEnum.Spent)) {
                setBunkeringEventStatus(BunkeringDateStatusEnum.spentBunkering);
            } else if (bunkeringsInAolGroupPeriod.some((bunkering) => bunkering.currentStatus?.status === BunkeringStatusEnum.Debunkered)) {
                setBunkeringEventStatus(BunkeringDateStatusEnum.debunkered);
            }
        } else {
            setBunkeringEventStatus(BunkeringDateStatusEnum.noBunkering);
        }
    }, [bunkeringEvents, bunkerings, props.date]);

    return (
        <BunkeringListItemWrapper
            onClick={() => props.onSelectCalendarDate(props.date)}
            key={'bunkering_list_date ' + formatDateTime(props.date, DateTimeFormat.queryFormats.dateOnly)}
        >
            <BunkeringListItem isSelected={props.isSelected} isValid={true}>
                <span>{prettifyDate(props.date)}</span>
                {bunkeringEventStatus !== BunkeringDateStatusEnum.noBunkering && BunkeringDateStatusIcon(bunkeringEventStatus)}
                <span className="icon-wrapper">{RobDateStatusIcon(robDateStatus)}</span>
            </BunkeringListItem>
        </BunkeringListItemWrapper>
    );
};

export default BunkeringDateListItem;
